var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bigbox", class: { navSm: !_vm.isOpenMenu } },
    [
      _c(
        "p",
        {
          staticClass: "collpanBtn",
          style: { height: _vm.collpanHeight },
          on: { click: _vm.changeMunuBig }
        },
        [
          _c("i", {
            staticClass: "ar_img",
            class: [_vm.isOpenMenu ? "el-icon-s-fold" : "el-icon-s-unfold"]
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bigbox2", style: { "padding-top": _vm.collpanHeight } },
        [
          _c(
            "div",
            { staticClass: "menuBox" },
            [
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    disabled: _vm.isOpenMenu,
                    effect: "dark",
                    content: _vm.$t("m.streamer_manage"),
                    placement: "right"
                  }
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/approval/anchor-approval" } },
                    [
                      _c("img", {
                        staticClass: "menuImg",
                        attrs: {
                          src: require("../assets/img/guanli_icon_02.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.$t("m.streamer_manage")))])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    disabled: _vm.isOpenMenu,
                    effect: "dark",
                    content: _vm.$t("m.sereamer_apply"),
                    placement: "right"
                  }
                },
                [
                  _c("router-link", { attrs: { to: "/anchor/management" } }, [
                    _c("img", {
                      staticClass: "menuImg",
                      attrs: {
                        src: require("../assets/img/guanli_icon_03.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("m.sereamer_apply")))])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    disabled: _vm.isOpenMenu,
                    effect: "dark",
                    content: "主播收益",
                    placement: "right"
                  }
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/revenues/anchor-revenues" } },
                    [
                      _c("img", {
                        staticClass: "menuImg",
                        attrs: {
                          src: require("../assets/img/guanli_icon_04.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.$t("m.anchor_earings")))])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5407f034", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5407f034","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageNav.vue
// module id = null
// module chunks = 